export enum MaskCreationStep {
  informations = 0,
  fill = 1,
  audience = 2,
  plan = 3,
  publish = 4,
  finalize = 5,
}
